export enum PrintOrderShippingEnums {
  SLIP = 'slip',
  MANIFEST = 'manifest',
  ADDRESS_LABEL = 'address_label',
  INSEMINATION_ROUTES = 'insemination_routes',
}
